import * as Yup from 'yup';

const validationSchema = Yup.object({
    venue_name: Yup.string()
        .trim()
        .max(50, 'Must be 50 characters or less')
        .matches(/^[A-Za-z0-9 ]*$/,
            'Venue Name can only contain letters and numbers. Special characters are not allowed.')
        .required('Venue name is required'),

    owner_name: Yup.string()
        .trim()
        .max(50, 'Must be 50 characters or less')
        .required('Owner name is required'),

    sports_type: Yup.array()
        .of(
            Yup.string().required('Sports type is required')
        )
        .min(1, 'At least one sports type is required'),

    address: Yup.string()
        .trim()
        .max(100, 'Must be 100 characters or less')
        .required('Address is required'),

    loc_city: Yup.string()
        .trim()
        .max(50, 'Must be 50 characters or less')
        .required('City is required'),

    payment_mode: Yup.array()
        .of(
            Yup.string().required('Payment mode is required')
        )
        .min(1, 'At least one payment mode is required'),

    latitude: Yup.string()
        .trim()
        .matches(/^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,6}/, 'Invalid latitude')
        .required('Latitude is required'),

    longitude: Yup.string()
        .trim()
        .matches(/^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,6}/, 'Invalid longitude')
        .required('Latitude is required'),

    venue_map_link: Yup.string()
        .trim()
        .matches(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/, 'Invalid link')
        .required('Venue map link is required is required'),

    banner_image: Yup.string()
        .trim()
        .required('Banner image is required'),

    gallery_image: Yup.array()
        .of(
            Yup.string().required('Gallery iamge is required')
        )
        .min(1, 'At least one gallery image is required')
});

export default validationSchema;